// src/pages/Admin/UsersCategory.js
import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import TitleWithBack from '../../components/common/TitleWithBack';

function UsersCategory() {
  const [categoryName, setCategoryName] = useState('');
  const [description, setDescription] = useState('');
  const [tooltip, setTooltip] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post('/api/user-categories', { name: categoryName, description })
      .then(() => {
        setTooltip('User category created successfully!');
        setTimeout(() => navigate('/admin/users/category/view'), 2000);
      })
      .catch(() => {
        setTooltip('Error creating user category.');
      });
  };

  return (
    <div className="container mt-2">
      <TitleWithBack title="Create User Category" />
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Category Name:</label>
          <input
            type="text"
            className="form-control"
            value={categoryName}
            onChange={(e) => setCategoryName(e.target.value)}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Description:</label>
          <textarea
            className="form-control"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="btn btn-primary">Create Category</button>
      </form>
      {tooltip && (
        <div className="mt-3 alert alert-info">
          {tooltip}
        </div>
      )}
    </div>
  );
}

export default UsersCategory;
